import Toaster from '@geneui/components/Toaster';

import { Connection } from 'utils';
import {
  GET_PAYMENT_FTD_RESTRICTION,
  SET_PAYMENT_FTD_RESTRICTION,
  GET_PAYMENT_MIN_MAX_RANGE,
  EDIT_PAYMENT_MIN_MAX_RANGE,
} from 'constants/api';
import { RESPONSE_SUCCESS_INFO } from 'constants/defines';

const getFtdRestrictions = () => Connection.post(GET_PAYMENT_FTD_RESTRICTION);

const setFtdRestrictions = async data => {
  const { result } = await Connection.post(SET_PAYMENT_FTD_RESTRICTION, data);

  if (result) {
    Toaster.success(RESPONSE_SUCCESS_INFO);
  }

  return result;
};

const getWithdrawalLimits = () => Connection.get(GET_PAYMENT_MIN_MAX_RANGE);

const setWithdrawalLimits = async data => {
  const { result } = await Connection.post(EDIT_PAYMENT_MIN_MAX_RANGE, data);

  if (result) {
    Toaster.success(RESPONSE_SUCCESS_INFO);
  }

  return result;
};
export default {
  getFtdRestrictions,
  setFtdRestrictions,
  getWithdrawalLimits,
  setWithdrawalLimits,
};
